import { gql } from "@apollo/client";

const UPDATE_PRODUCT_LAKE_INVENTORY = gql`
  mutation updateProductLakeInventory($input: UpdateInventory) {
    updateProductLakeInventory(input: $input) {
      status
      data
      error
    }
  }
`;
export default UPDATE_PRODUCT_LAKE_INVENTORY;
